import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { AutoCandidate } from "@opus-dt/shared-types";
import { MachineThroughput } from "./charts/MachineThroughput";

interface MachineThroughputCardProps {
  winner: AutoCandidate | null;
  baseline: AutoCandidate | null;
}

/**
 * "onde o ganho acontece".
 *
 * Só aparece quando as duas configurações comparadas trazem detalhe por máquina: lote antigo
 * e candidato que falhou vêm com a lista vazia, e um card vazio prometendo um gráfico é pior
 * que card nenhum.
 */
export function MachineThroughputCard({ winner, baseline }: MachineThroughputCardProps) {
  if (!winner || !baseline || winner.perMachine.length === 0 || baseline.perMachine.length === 0) {
    return null;
  }
  return (
    <Card>
      <CardHeader>
        <CardTitle>Vazão efetiva por máquina</CardTitle>
      </CardHeader>
      <CardContent>
        <MachineThroughput
          base={baseline.perMachine}
          winner={winner.perMachine}
          winnerLabel="Recomendado"
        />
        <p className="mt-3 text-[11px] leading-relaxed text-muted-foreground">
          O agregado diz <b>quanto</b> melhorou; esta é a leitura que diz <b>onde</b>. O gargalo é o
          que o motor apontou nesta rodada — mexer nele é o que move a linha inteira.
        </p>
      </CardContent>
    </Card>
  );
}
